module.exports = __webpack_public_path__ + "static/media/sogecap.38402145.svg";